import React from "react";

const Field = ({ id, name, value, onChange, placeholder, type = "text" }) => {
  return (
    <input
      id={id}
      name={name}
      type={type}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className={`w-full h-12 md:h-20 rounded-lg px-4 py-3 text-white bg-transparent border focus:outline-none focus:border-white font-normal text-[16px] md:text-[20px] leading-[100%] tracking-[0%]  ${
        value ? "border-white" : "border-[#7D7D7D]"
      }`}
    />
  );
};

export default Field;
